import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Input, Grid, Dropdown, Form, TextArea } from 'semantic-ui-react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loading';
import Server from '../../../functions/server';
import AddJob from './AddJob';

export default class JobCard extends React.Component {

    state = {
        item: {}, jobs: []
    }

    getJobs = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Job Cards' })
        $.ajax({
            type: 'POST', data: { 'id': context.props.item.id }, 
            url: Server() + 'Sales/JobCard/getjobcard.php',
            success: function (data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    context.setState({ jobs: data, load: false, dialog: true })
                } catch (error) {
                    context.setState({ load: false })
                    alert(error)
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    refresh = () => {
        this.props.getJobCardMaster();
        this.setState({ dialog: false })
    }

    convertIntoNumber(value) {
        try {
            value = Number(value);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    makeDecimal(value) {
        try {
            value = value.toFixed(2);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    changeStatus = (id, status) => {
        let context = this;
        context.setState({ load: true, message: 'Edit Spares', })
        $.ajax({
            type: 'POST', data: { id, status }, url: Server() + 'Sales/JobCard/ChangeJobStatus.php',
            success: function (data) {
                if (data == 1) {
                    context.setState({ editDialog: false, load: false })
                    context.refresh();
                }
                else {
                    alert(data)
                    console.log(data);
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    printJobCard = () => {
        alert(1)
    }

    render() {
        let { dialog, jobs, editDialog, item, load, message, search } = this.state;
        let masterItems = this.props.item;
        let i = 1;
        return (
            <div>
                <center>
                    <u onClick={this.getJobs} style={{color: 'blue', cursor: 'pointer'}}>Job</u>
                </center>
                <Loading load={load} message={message} />
                <Dialog fullWidth={false} maxWidth={'md'} open={dialog}
                    onClose={ () => { this.setState({ dialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '800px'}}> {"Jobs"} </DialogTitle>
                    <DialogContent>
                        <table width="100%" id="table">
                            <tr>
                                <th id='tableheader'><center>Sino</center></th>
                                <th id='tableheader'><center>Planned Date</center></th>
                                <th id='tableheader'><center>Machine</center></th>
                                <th id='tableheader'><center>Issue</center></th>
                                <th id='tableheader'><center>Machanic Name</center></th>
                                <th id='tableheader'><center>Work Mode</center></th>
                                <th id='tableheader'><center>Estimate Time</center></th>
                                <th id='tableheader'><center>Rate</center></th>
                                <th id='tableheader'><center>Tax</center></th>
                                <th id='tableheader'><center>Total</center></th>
                                <th id='tableheader'><center>Status</center></th>
                                { masterItems.status != '2' || masterItems.status != 2 ?
                                    <th id='tableheader'><center>Action</center></th>
                                    :
                                    null
                                }
                            </tr>
                            {
                                jobs.map((c) => {
                                    console.log(c);
                                    let price = this.convertIntoNumber(c.price);
                                    let tprice = this.convertIntoNumber(c.tprice);
                                    return (
                                        <tr>
                                            <td>{i++}</td>
                                            <td>{c.date}</td>
                                            <td>{this.props.item.machine}</td>
                                            <td>{c.title}</td>
                                            <td>{c.worker_name}</td>
                                            <td>{c.mode}</td>
                                            <td>{c.estimate_time+" Hour(s)"}</td>
                                            <td style={{textAlign: 'right'}}>{this.makeDecimal(price)}</td>
                                            <td style={{textAlign: 'right'}}>{c.tax}</td>
                                            <td style={{textAlign: 'right'}}>{tprice}</td>
                                            <td style={{textAlign: 'right'}}>
                                                {
                                                    c.status == 1 || c.status == '1' ? 
                                                    <div  style={{color: 'blue', cursor: 'pointer'}} onClick={ () => this.changeStatus(c.id, 2)}>Process</div> : 
                                                    <div>
                                                        { masterItems.status != '2' || masterItems.status != 2 ?
                                                            <div style={{color: 'green', cursor: 'pointer'}} 
                                                                 onClick={ () => this.changeStatus(c.id, 1)}>Completed</div>
                                                            :
                                                            <div style={{color: 'green', cursor: 'pointer'}}>Completed</div>
                                                        }
                                                    </div>
                                                    
                                                }
                                            </td>
                                            { masterItems.status != '2' || masterItems.status != 2 ?
                                                <td style={{textAlign: 'right'}}><AddJob edit={true} item={c} refresh={this.refresh} /></td>
                                                :
                                                null
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </table>
                        { masterItems.status != '2' || masterItems.status != 2 ?
                            <center>
                                <br/>
                                <AddJob item={this.props.item} refresh={this.refresh} />
                            </center>
                            :
                            null
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}